/**
 * Height of the fixed top navbar in pixels.
 * Used by TopNavBar (spacer div) and SideBar (sticky offset + height calc).
 * Update here if the navbar height ever changes.
 */
export const NAVBAR_HEIGHT = 64;
